import React, { Component } from 'react'
import Navbar from '../../components/navbar/navbar';
import "./aboutUs.css";

export default class AboutUs extends Component {
  render() {
    return (
      <div className="aboutus-wholepage">
       
        <div className="aboutus-secondsec">
          <div className="aboutus-item-container" id="aboutUs">
            <h1>About Us</h1>
            <div className="aboutus-p-container">
              <p>
              TheoryDev is all about providing web development services like Html, CSS, JavaScript , React , web design , logo design ,etc... to our customers who want their entrepreneurship skills to reach the masses of this virtually connected world .We wish to establish a stiff web base for our customers and to provide them with the best of our potentials at an affordable rate. We believe customer's satisfaction as our main goal and so we try to give our full effort to fulfill it.
                  </p>
            </div>
           
          </div>

            
        </div>
      </div>
    );
  }
}
